import React from "react";

function Toolbar({title, children}:any) {
  return (
    <>
    {/*begin::Toolbar container*/}
    <div
                id="kt_app_toolbar_container"
                className="app-container  container-xxl d-flex flex-stack "
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3 ">
                  {/*begin::Title*/}
                  <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                    {title}
                  </h1>
                  {/*end::Title*/}
                  {/*begin::Breadcrumb*/}
                  <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                    {/*begin::Item*/}
                    <li className="breadcrumb-item text-muted">
                      <a
                        href="https://preview.keenthemes.com/metronic8/demo1/index.html"
                        className="text-muted text-hover-primary"
                      >
                        Home{" "}
                      </a>
                    </li>
                    {/*end::Item*/}
                    {/*begin::Item*/}
                    <li className="breadcrumb-item">
                      <span className="bullet bg-gray-500 w-5px h-2px" />
                    </li>
                    {/*end::Item*/}
                    {/*begin::Item*/}
                    <li className="breadcrumb-item text-muted">
                      {title}{" "}
                    </li>
                    {/*end::Item*/}
                  </ul>
                  {/*end::Breadcrumb*/}
                </div>
                {/*end::Page title*/}
                {/*begin::Actions*/}
                <div className="d-flex align-items-center gap-2 gap-lg-3">
                  {/*begin::Filter menu*/}
                  <div className="m-0">
                    {/*begin::Menu toggle*/}
                    {children}
                    {/*end::Menu 1*/}
                  </div>
                  {/*end::Filter menu*/}
                </div>
                {/*end::Actions*/}
              </div>
              {/*end::Toolbar container*/}
      
</>
  );
}

export default Toolbar;
